// @flow weak
/*
Sniff actions and track.
*/

import _ from 'lodash';
import { ROUTE_TO } from 'redux-router-kit';

import TrackActions from './tracking/Actions';

export default ({ dispatch }) => {
  const types = {
    [ROUTE_TO]: action => {
      void TrackActions.trackPageViewEvent();

      const path = _.get(action, ['meta', 'location', 'pathname']);
      const href = _.get(action, ['meta', 'location', 'href']);

      if (window.DD_RUM) {
        window.DD_RUM.addAction('legacy_frontend.route', {
          path: path || window.location.pathname,
          href: href || window.location.href,
          referrer: document.referrer,
        });
      }

      dispatch(TrackActions.gaPageTrack(path));
    },
  };

  return next => action => {
    if (action && types[action.type]) {
      types[action.type](action);
    }

    return next(action);
  };
};
